import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import addressAutocomplete from '../components/AddressAutocomplete/addressAutocompleteSlice';
import campaign from '../features/campaign/campaignSlice';
import recentDonationPanel from '../features/recentDonationPanel/recentDonationPanelSlice';
import donorsList from '../features/donorsList/donorsListSlice';
import teamsList from '../features/layersList/teamsListSlice';
import teamDonorsList from '../features/donorsList/teamDonorsListSlice';
import checkoutPopup from '../features/checkout/checkoutPopupSlice';
import checkout from '../features/checkout/checkoutSlice';
import cart from '../features/cart/cartSlice';
import notifications from '../features/notifications/notificationsSlice';
import lastDonation from '../features/checkout/lastDonationSlice';
import donationFlasher, {
    name as donationFlasherName,
} from '../components/DonationFlasher/donationFlasherSlice';
import heroSlider from '../components/HeroSlider/heroSliderSlice';
import sharePanel from '../components/SharePanel/sharePanelSlice';

export default history => ({
    addressAutocomplete,
    campaign,
    checkoutPopup,
    checkout,
    cart,
    [donationFlasherName]: donationFlasher,
    donorsList,
    lastDonation,
    notifications,
    recentDonationPanel,
    router: connectRouter(history),
    teamsList,
    teamDonorsList,
    ui: combineReducers({
        heroSlider,
        sharePanel,
    }),
});
